// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__ZW8Ik","banner":"Hero_banner__vJnhR","grow":"Hero_grow__iy6ou"};